import * as actions from './slice'

const getTenantData = {
  eventName: 'getTenantData',
  onSuccess: [{ redux: true, action: actions.setTenantData }]
}

export { getTenantData }
